import { LookBackMeasurement } from '../LookBackPeriod';

const MINUTES_IN_AN_HOUR = 60;
const MINUTES_IN_A_DAY = MINUTES_IN_AN_HOUR * 24;

const convertFromHours = value => value * MINUTES_IN_AN_HOUR;
const convertFromDays = value => value * MINUTES_IN_A_DAY;

export const convertToMinutes = (value: number, measurement: LookBackMeasurement) => {
  switch (measurement) {
    case 'hours':
      return convertFromHours(value);
    case 'days':
      return convertFromDays(value);
    default:
      throw new Error('Unable to convert look back to minutes');
  }
};
